import React from "react";
import Navbar from "./components/Navbar";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import AboutUs from "./pages/AboutUs";
import Event from "./pages/Event";
import Gellery from "./pages/Gellery";
import Import from "./pages/Import";
import Export from "./pages/Export";
import ContactUs from "./pages/ContactUs";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/event" element={<Event />} />
        <Route path="/gellery" element={<Gellery />} />
        <Route path="/import" element={<Import />} />
        <Route path="/export" element={<Export />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
